"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postNetlifyForm = exports.createFormData = exports.lorem = exports.isPathActive = exports.nodes = exports.mapIndexed = exports.getRichText = exports.getUnlessEmpty = exports.getSearchQuery = exports.pathFor = exports.arrayPathFor = exports.getNormalizedUID = exports.isBrowser = exports.isInternal = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _fp = require("lodash/fp");

var _querystring = _interopRequireDefault(require("querystring"));

var _fastLoremIpsum = _interopRequireDefault(require("fast-lorem-ipsum")); // @private
// Returns path without leading and/or trailing '/'.


var _sanitizePath = (0, _fp.replace)(/(^\/|\/$)/g, ''); // @private
// If the argument is empty, returns `undefined`. If non-empty, it is returned
// as is.


var _strictNonEmpty = (0, _fp.cond)([[_fp.isEmpty, (0, _fp.always)(undefined)], [_fp.T, _fp.identity]]); // Returns true if the URL is internal, false otherwise.


var isInternal = function isInternal(s) {
  return (0, _fp.isString)(s) && /^\/(?!\/)/.test(s);
}; // Constant is true if in the browser, false otherwise.


exports.isInternal = isInternal;
var isBrowser = typeof window !== 'undefined'; // Returns a normalized UID for a given Prismic node. The node must have a
// `uid` field.

exports.isBrowser = isBrowser;
var getNormalizedUID = (0, _fp.cond)([[(0, _fp.propEq)('uid', 'home'), (0, _fp.always)(null)], [_fp.T, (0, _fp.get)('uid')]]); // Returns the parts of a full URL path (excluding host) as an array for a
// given Prismic node. The node must have a `uid` field.

exports.getNormalizedUID = getNormalizedUID;
var arrayPathFor = (0, _fp.compose)(_fp.compact, _fp.flattenDeep, _fp.castArray, (0, _fp.cond)([// If parent exists, recursively construct path with parents' paths.
[(0, _fp.has)('data.parent.document[0].uid'), (0, _fp.compose)(function (x) {
  return [(0, _fp.compose)(arrayPathFor, (0, _fp.get)('data.parent.document[0]'))(x), getNormalizedUID(x)];
})], // Default to the node's normalized UID.
[_fp.T, getNormalizedUID]])); // Returns the full URL path (excluding host) for a given Prismic node. The
// computed path contains leading and trailing forward slashes. The node must
// have a `uid` field.

exports.arrayPathFor = arrayPathFor;
var pathFor = (0, _fp.compose)((0, _fp.join)('/'), (0, _fp.concat)(_fp.__, null), (0, _fp.concat)(null), arrayPathFor); // Returns the value of a given key in the location search query.

exports.pathFor = pathFor;
var getSearchQuery = (0, _fp.curry)(function (key, location) {
  return (0, _fp.compose)((0, _fp.get)(key), _querystring.default.parse, (0, _fp.get)('search'))(location);
}); // Lodash's get function, but if the value is empty via `isEmpty`, it returns
// `undefined`.

exports.getSearchQuery = getSearchQuery;
var getUnlessEmpty = (0, _fp.compose)(_strictNonEmpty, _fp.get); // Lodash's get function, but specialized for Prismic Rich Text fields. Gets
// the text value of the field and returns the HTML value if it is not empty.

exports.getUnlessEmpty = getUnlessEmpty;
var getRichText = (0, _fp.compose)((0, _fp.cond)([[(0, _fp.compose)(_fp.isEmpty, (0, _fp.get)('text')), (0, _fp.always)(undefined)], [_fp.T, (0, _fp.get)('html')]]), _fp.get); // Lodash's map function with indexes. Each item in the collection is converted
// to a key-value tuple.

exports.getRichText = getRichText;
var mapIndexed = (0, _fp.curry)(function (iteratee, collection) {
  return (0, _fp.compose)((0, _fp.map)(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    return iteratee([(0, _fp.parseInt)(10, k), v]);
  }), _fp.entries)(collection);
}); // Returns an array of nodes from the connection data provided as a result of a
// GraphQL query.

exports.mapIndexed = mapIndexed;
var nodes = (0, _fp.compose)((0, _fp.map)('node'), (0, _fp.get)('edges')); // Returns true if path is a child of the current location, false otherwise.

exports.nodes = nodes;
var isPathActive = (0, _fp.curry)(function (path, location) {
  var sanitizedPath = _sanitizePath(path);

  var sanitizedLocationPath = (0, _fp.compose)(_sanitizePath, (0, _fp.get)('pathname'))(location);
  if ((0, _fp.isEmpty)(sanitizedPath) || (0, _fp.isEmpty)(sanitizedLocationPath)) return false;
  return (0, _fp.startsWith)(sanitizedPath, sanitizedLocationPath);
}); // Returns a string of lorem ipsum of a requested length.

exports.isPathActive = isPathActive;

var lorem = function lorem() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return (0, _fp.capitalize)((0, _fastLoremIpsum.default)(length, 'w'));
}; // Returns a FormData object containing key-value data from the provided
// object.


exports.lorem = lorem;

var createFormData = function createFormData(data) {
  var formData = new FormData();

  var _arr = Object.keys(data);

  for (var _i = 0; _i < _arr.length; _i++) {
    var key = _arr[_i];
    formData.append(key, data[key]);
  }

  return formData;
}; // Posts a form to Netlify with the provided form name and values. Returns true
// if successful, false otherwise.


exports.createFormData = createFormData;

var postNetlifyForm = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(formName, values) {
    var response;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch('/', {
              method: 'post',
              body: createFormData((0, _objectSpread2.default)({
                'form-name': formName
              }, values))
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", (0, _fp.compose)((0, _fp.inRange)(200, 300), (0, _fp.get)('status'))(response));

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
            return _context.abrupt("return", false);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 7]]);
  }));

  return function postNetlifyForm(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();

exports.postNetlifyForm = postNetlifyForm;